import App from '@framework/baseApp';
import createStore from '@store/index';
import entry from '@client/page/mobile/view/entry/share/profile/index.vue';

export default new App({ entry, createStore }).bootstrap();